import { render, staticRenderFns } from "./NuevoVecino.vue?vue&type=template&id=158908b4&"
import script from "./NuevoVecino.vue?vue&type=script&lang=js&"
export * from "./NuevoVecino.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports